export default __webpack_public_path__ + "static/media/ekomi-stamp@2x.df3260b3.png";